import {
  Typography,
  Box,
  BoxProps,
} from '@mui/material';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { styled } from '@mui/material/styles';
import { mapPlanToPalette } from '../../AppTheme';

const ConfirmationHeaderWrapper = styled(Box)<BoxProps>(({ theme }) => ({
  padding: '16px',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
}));

interface ConfirmationHeaderProps {
  selectedPlan: string
}

export function ConfirmationHeader({ selectedPlan }: ConfirmationHeaderProps) {
  const palette = useMemo(() => mapPlanToPalette(selectedPlan), [selectedPlan]);

  return (
    <ConfirmationHeaderWrapper bgcolor={`${palette}.main`} data-testid="headerWrapper">
      <Typography variant="h4">
        <FormattedMessage
          id={`${selectedPlan}-plan-label`}
        />
      </Typography>
    </ConfirmationHeaderWrapper>
  );
}
